import {
  emptyValidator,
  formValidator,
  numberReangeValidator,
  mobilePhoneNotMenValidator,
  mobilePhoneMenValidator,
} from "../../validators";

const requestInitiationValidation = {
  reqLCustomerId: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  reqLPlantId: {
    validators: [emptyValidator()],
    name: "Plant Name",
  },
  reqContactPerson: {
    validators: [emptyValidator()],
    name: "Contact person",
  },
  reqContactNumber: {
    validators: [emptyValidator(), mobilePhoneMenValidator()],
    name: "Contact Number",
  },
  reqShipmentType: {
    validators: [emptyValidator()],
    name: "Shipment Type",
  },
  reqConsolidateAllowed: {
    validators: [emptyValidator()],
    name: "Consolidate Type",
  },
};

const transporterCreationValidation = {
  reqItemTypes: {
    validators: [emptyValidator()],
    name: "Item Type",
  },
  reqManageItems: {
    validators: [emptyValidator()],
    name: "Manage Items",
  },
  reqMultiConsignee: {
    validators: [emptyValidator()],
    name: "Multi Consignee",
  },
  reqVehicleTypeId: {
    validators: [emptyValidator()],
    name: "Vehicle Type",
  },
};

const otherValidationState = {
  rotChargeType: {
    validators: [emptyValidator()],
    name: "Charge Type",
  },
  // rotValue: {
  //   validators: [emptyValidator(), numberReangeValidator(0)],
  //   name: "Value",
  // },
  rotStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
};

const singleConsigneetransporterCreationValidation = {
  reqItemTypes: {
    validators: [emptyValidator()],
    name: "Item Type",
  },
  reqManageItems: {
    validators: [emptyValidator()],
    name: "Manage Items",
  },
  reqMultiConsignee: {
    validators: [emptyValidator()],
    name: "Multi Consignee",
  },
  reqVehicleTypeId: {
    validators: [emptyValidator()],
    name: "Vehicle Type",
  },
  rcoCbm: {
    validators: [emptyValidator()],
    name: "CBM",
  },
};

export const validateQuickRequestInitiation=(data)=>{
    return formValidator(data, requestInitiationValidation);
};

export const validateQuickRequestTransport=(data)=>{
    return formValidator(data, transporterCreationValidation);
};

export const validateSingleConsigneeQuickRequestTransport=(data)=>{
    return formValidator(data, singleConsigneetransporterCreationValidation);
};

export const validateQuickRequestOther=(data)=>{
    return formValidator(data, otherValidationState);
};

const locationValidation = {
  rlkLocation: {
    validators: [emptyValidator()],
    name: "Location",
  },
  rlkArrivalEta: {
    validators: [emptyValidator()],
    name: "Arrival Time",
  },
  rlkDepartureEta: {
    validators: [emptyValidator()],
    name: "Departure Time",
  },
};

export const validateQuickRequestLocation=(data)=>{
    return formValidator(data, locationValidation);
};

const consigneeValidationRules = {
  rcoLocation: {
    validators: [emptyValidator()],
    name: "Location",
  },
  rcoConsignee: {
    validators: [emptyValidator()],
    name: "Consignee",
  },
  rcoConsignmentType: {
    validators: [emptyValidator()],
    name: "Consignement Type",
  },
  rcoCbm: {
    validators: [emptyValidator()],
    name: "CBM",
  },
};

export const validateQuickRequestConsignee=(data)=>{
    return formValidator(data, consigneeValidationRules);
}
